// extracted by mini-css-extract-plugin
module.exports = {"tagContent":"styles_tagContent__1qJn6"};